/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Facility information for the receiver of the fax
 * @export
 * @interface FindAllSourceTags200ResponseDataInner
 */
export interface FindAllSourceTags200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof FindAllSourceTags200ResponseDataInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllSourceTags200ResponseDataInner
     */
    name: string;
}

/**
 * Check if a given object implements the FindAllSourceTags200ResponseDataInner interface.
 */
export function instanceOfFindAllSourceTags200ResponseDataInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function FindAllSourceTags200ResponseDataInnerFromJSON(json: any): FindAllSourceTags200ResponseDataInner {
    return FindAllSourceTags200ResponseDataInnerFromJSONTyped(json, false);
}

export function FindAllSourceTags200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceTags200ResponseDataInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FindAllSourceTags200ResponseDataInnerToJSON(value?: FindAllSourceTags200ResponseDataInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

